export const PLAY_ICONS = {
  DEFAULT: {
    PLAY: 'play',
    PAUSE: 'pause',
  },
  SIMPLE: {
    PLAY: 'playsimple',
    PAUSE: 'pausesimple',
    SIZE: 42,
  },
  SIMPLE_DARK: {
    PLAY: 'playsimple',
    PAUSE: 'pausesimple',
    SIZE: 50,
  },
  SIMPLE_DARK_LARGE: {
    PLAY: 'playsimple',
    PAUSE: 'pausesimple',
    SIZE: 100,
  },
};

export const PLAY_ICON_TYPES = {
  DEFAULT: 'DEFAULT',
  SIMPLE: 'SIMPLE',
  SIMPLE_DARK: 'SIMPLE_DARK',
  SIMPLE_DARK_LARGE: 'SIMPLE_DARK_LARGE',
};

export const PLAYBACK_SPEEDS = {
  DEFAULT_SPEED: 1,
  DELTA: 0.5,
  MAX: 1.5,
  MIN: 0.5,
};
